export const calculateEmailBottomPadding = (filesLength: number): string => {
  const MAX_FILES = 3;
  const FILE_HEIGHT = 40;
  const TOOLBAR_HEIGHT = 57;
  const MAX_HEIGHT = 120;

  const height =
    (filesLength < MAX_FILES ? filesLength * FILE_HEIGHT : MAX_HEIGHT) +
    TOOLBAR_HEIGHT;

  return `${height}px`;
};
